<template>
  <div class="gitex-solution">
    <div class="gitex-solution__card">
      <img
        :src="`${staticUrl}/images/gitex-sol-1.webp`"
        alt=""
        class="gitex-solution__card-img"
      />
      <div class="gitex-solution__card-title">
        {{ $t('designers') }}
      </div>
      <div class="gitex-solution__card-desc">
        {{ $t('gitexInfoDes') }}
      </div>
    </div>
    <div class="gitex-solution__card">
      <img
        :src="`${staticUrl}/images/gitex-sol-2.webp`"
        alt=""
        class="gitex-solution__card-img"
      />
      <div class="gitex-solution__card-title">
        {{ $t('developer') }}
      </div>
      <div class="gitex-solution__card-desc">
        {{ $t('gitexInfoDev') }}
      </div>
    </div>
    <div class="gitex-solution__card">
      <img
        :src="`${staticUrl}/images/gitex-sol-3.webp`"
        alt=""
        class="gitex-solution__card-img"
      />
      <div class="gitex-solution__card-title">
        {{ $t('households') }}
      </div>
      <div class="gitex-solution__card-desc">
        {{ $t('gitexInfoHouse') }}
      </div>
    </div>
    <div class="gitex-solution__card">
      <img
        :src="`${staticUrl}/images/gitex-sol-4.webp`"
        alt=""
        class="gitex-solution__card-img"
      />
      <div class="gitex-solution__card-title">
        {{ $t('furnComp') }}
      </div>
      <div class="gitex-solution__card-desc">
        {{ $t('gitexInfoFurnComp') }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useRuntimeConfig} from '#imports';
const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
</script>

<style scoped lang="scss">
.gitex-solution {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;

  &__card {
    display: flex;
    flex-direction: column;
    padding: 24px;
    background: #f6f8fd;
    border: 1px solid #e1e5f0;
    border-radius: 16px;

    &-img {
      height: 216px;
      width: 216px;
      border-radius: 8px;
      object-fit: cover;
    }

    &-title {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 0.02em;
      color: #e31e33;
      margin-top: 16px;
    }

    &-desc {
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
      letter-spacing: 0.03em;
      color: #64686e;
      margin-top: 8px;
    }
  }

  @media (max-width: $lg) {
    flex-direction: column;
    display: flex;
    &__card {
      padding: 16px;

      &-img {
        width: 100%;
        height: 364px;
      }

      &-title {
        font-size: 16px;
        line-height: 21px;
        letter-spacing: 0.02em;
        margin-top: 16px;
      }

      &-desc {
        font-size: 15px;
        line-height: 140%;
        letter-spacing: 0.03em;
        margin-top: 4px;
      }
    }
  }
}
</style>
